import { Link } from 'react-router-dom';
import { Layout } from '../components/Layout';

export function NotFoundPage() {
  return <Layout>
    <div className="bg-white rounded-2xl shadow-medium p-10 text-center">
      <div className="text-6xl mb-4">🔍</div>
      <h1 className="text-3xl font-bold text-brand-oscuro mb-2">404</h1>
      <p className="text-neutral-600 mb-6">Esta página no existe.</p>
      <Link to="/" className="inline-block px-6 py-3 bg-brand-primario hover:bg-brand-energico text-white font-semibold rounded-lg">Ir al inicio</Link>
    </div>
  </Layout>;
}
